import { memo, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useClickAway } from 'react-use';
import SelectCustomAsyncAppointment from './selectCustomAsyncAppointment';

const SearchAreaAsyncAppointment = ({
  modalTitle,
  closeAction,
  handleOnInputChange,
  handleSearchOrNew,
  options,
  setSearchOptions,
  searchQuery,
  setSearchQuery,
  placeholder,
  selectedInputs,
  handleClickOnRightArrow,
}) => {
  const ref = useRef(null);
  useClickAway(ref, (e) => {
    if (options?.length > 0) {
      setTimeout(() => {
        setSearchOptions([]);
        setSearchQuery('');
      }, 0);
    }
  });

  return (
    <Row>
      <Col
        md={12}
        sm={6}
        style={{ position: 'relative' }}
        className="search-parent1"
        ref={ref}
      >
        <SelectCustomAsyncAppointment
          handleInputChange={handleOnInputChange}
          onChange={handleSearchOrNew}
          options={options}
          placeholder={placeholder}
          searchQuery={searchQuery}
          selectedInputs={selectedInputs}
        />
        {/* <svg width="16" height="16" className="search-icon" viewBox="0 0 20 20">
          <path
            d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
            stroke="currentColor"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg> */}
        {/* <CreateBtn
          clickAction={handleSearchOrNew}
          itemNewData={[{ customOption: true, name: searchQuery }]}
        /> */}
      </Col>
    </Row>
  );
};

export default memo(SearchAreaAsyncAppointment);
